import { Component, OnDestroy, OnInit } from '@angular/core';
import {BookService} from '../../services/public/book.service';
import {UserModel} from '../../models/authentication/user.model';
import {BookModel} from '../../models/edu-admin/book.model';
import {BookVersionModel} from '../../models/edu-admin/book-version.model';
import {Router} from '@angular/router';
import {AdminSelectCountryService} from '../shared/admin-select-country/admin-select-country.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-school-books',
  templateUrl: './admin-books.component.html',
  styleUrls: ['./admin-books.component.css']
})
export class AdminBooksComponent implements OnInit, OnDestroy {

  books: BookModel[] = [];
  private countrySub: Subscription;

  constructor(public bookSv: BookService,
              private router: Router,
              private selectCountrySv: AdminSelectCountryService) { }

  ngOnInit() {
    this.fetchBooks();
    this.countrySub = this.selectCountrySv.countryChanged$.subscribe(() => this.fetchBooks());
  }

  ngOnDestroy() {
    this.countrySub.unsubscribe();
  }

  private fetchBooks() {
    this.bookSv.fetchPublicBooks(UserModel.getAdminCountry()).subscribe((books) => {
      this.books = books;
    });
  }

  onAddBookClicked() {

    this.router.navigate(['admin', 'books', 'create']);

  }

  onBookClicked(book: BookModel) {

    this.router.navigate(['admin', 'books', book._id, 'edit']);

  }

  onAddBookVersionClicked(book: BookModel) {

    this.router.navigate(['admin', 'books', book._id, 'versions', 'create']);

  }

  onBookVersionClicked(book: BookModel, bookVersion: BookVersionModel) {

    this.router.navigate(['admin', 'books', book._id, 'versions', bookVersion._id, 'edit']);;

  }

}
